import React, { useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { MAP_ELEMENT } from "../../../contexts/WorldMapContext/constants";
import { PoiMarker } from "../../../contexts/WorldMapContext/Marker";
import { selectLocation } from "../../../util/store/location/constants";
import { selectViewMode } from '../../../util/store/selectors';
import { VIEW_MODE } from '../../../util/varibles/permission';
import { dashboardActions } from "../reducer";

interface IProps {
    ids: Set<string>
}

const Pois: React.FC<IProps> = ({ ids }) => {
    const source = useSelector(selectLocation.data);
    const viewMode = useSelector(selectViewMode);
    const dispatch = useDispatch();

    const onClick = useCallback((data: any) => {
        dispatch(dashboardActions.showInfo({ data, targetType: MAP_ELEMENT.POI }));
    }, [dispatch])

    if (viewMode === VIEW_MODE.SITE)
        return null;

    return <>
        {source.map(item => <PoiMarker
            key={item.id}
            data={item}
            show={ids.size === 0 || ids.has(item.id)}
            onClick={() => onClick(item)}
        />)}
    </>;
};

export default Pois;
